import React from 'react';
import styled from 'styled-components';
import ContentWrapper from "../styles/ContentWrapper";

const ColoringOptions = () => {

    const StyledThing = styled.div`
      
    `;

    return (
        <StyledThing>
            <ContentWrapper>

            </ContentWrapper>
        </StyledThing>
    );
};

export default ColoringOptions;



// WEBPACK FOOTER //
// ./src/components/en/faq-coloring-options.js